//function sideScroll(){
//    console.log("sideScroll");
//
//    var self = this;
//
//    this.$window = $(window);
//    this.winW = this.$window.width();
//    this.$header = $('#js_globalHeader');
//    this.MIN_WIDTH = 1212;
//    this.sideScrollFlg = false;
//
//    this.$window.on('resize',self.resize);
//    this.$window.on('scroll',self.scrollLeft);
//}
//
//sideScroll.prototype = {
//
//    resize : function(){
//        console.log("resize");
//        this.winW = this.$window.width();
//    },
//
//    scrollLeft : function(){
//        var wideSize = this.$window.scrollLeft();
//        console.log(wideSize);
//        this.$header.css({'left': -wideSize});
//    }
//};

module.exports = function sideScroll(){

    var $window = $(window);
    var winW = $window.width();
    var $header = $('#js-nav');
    //var MIN_WIDTH = 1212;
    //var sideScrollFlg = false;

    $window.on('resize',function(){
        winW = $window.width();
    });

    $window.on('scroll.leftScroll',function(){
        var wideSize = $window.scrollLeft();
        $header.css({'left': -wideSize});
    });
}();


/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/pc/assets/js/module/headerSideScroll.js
 **/